module.exports = __webpack_public_path__ + "static/media/documentation.0b15cde7.md";